import { Field } from '../../util/components/resource/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import {
  IdentityCarrier,
  IdentityPayload,
} from '../../util/identity/lib/identity.interfaces';
import { PaymentHistory } from '../payment/payment-history.model';
import { Child } from '../child/child.model';
import { Person } from '../_lib/person';
import { Address } from '../_lib/address';

@Endpoint('customers', 'Customer')
export class Customer
  extends ApiResource<Customer>
  implements Person, Address, IdentityCarrier
{
  @Field({ label: $localize`First name` })
  firstName!: string;

  @Field({ label: $localize`Last name` })
  lastName!: string;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  @Field({ label: $localize`Phone number` })
  phoneNumber!: string;

  @Field({ label: $localize`Email` })
  email!: string;

  @Field({ label: $localize`Bank account` })
  bankAccountNumber?: string;

  @Field({ label: $localize`Language` })
  language!: string;

  @Field({ label: $localize`Address` })
  address!: string;

  @Field({ label: $localize`Postal code` })
  zipCode!: string;

  @Field({ label: $localize`City` })
  city!: string;

  @Field({ label: $localize`Country` })
  country!: string;

  @Field({ includeFilter: false })
  identities!: IdentityPayload[];

  @Field({ type: () => Child, readonly: true, label: $localize`Children` })
  children!: Child[];

  @Field({ readonly: true, includeFilter: false })
  paymentHistory!: PaymentHistory;

  override toLabel(): string {
    return this.fullName;
  }
}
